import { render, staticRenderFns } from "./YA_Logo.vue?vue&type=template&id=2a1b6fbc&scoped=true"
import script from "./YA_Logo.vue?vue&type=script&lang=js"
export * from "./YA_Logo.vue?vue&type=script&lang=js"
import style0 from "./YA_Logo.vue?vue&type=style&index=0&id=2a1b6fbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1b6fbc",
  null
  
)

export default component.exports